import React from 'react';
import { useProjectCtx } from 'state/project/ProjectCtx';
import { NoAccessReason } from 'types/access';
import AppLayout from './Layout/AppLayout';
import NoAuthView from './Views/NoAuthView';

interface IDescopeAuthProviderAppBlockerProps {
	children: React.ReactNode;
}

const DescopeAuthProviderAppBlocker: React.FC<
	IDescopeAuthProviderAppBlockerProps
> = ({ children }) => {
	const { projectId, initialized } = useProjectCtx();

	if (!projectId && !initialized) {
		return (
			<AppLayout>
				<NoAuthView noAccessReason={NoAccessReason.NO_AUTH} />
			</AppLayout>
		);
	}

	if (!projectId) {
		return (
			<AppLayout>
				<NoAuthView noAccessReason={NoAccessReason.UNKNOWN_PROJECT} />
			</AppLayout>
		);
	}

	return children;
};

export default DescopeAuthProviderAppBlocker;
